<div class="bg-check-container">

    <!-- Banner Section -->
    <section class="bg-check-banner">

        <div class="banner-container">

            <div class="banner-content">
                <div class="trusted-badge">
                    <img src="../../../../../assets/images/background-check/shield-1.svg">
                    <p class="text">Trusted Background Check Partner</p>
                </div>
                <p class="heading">Get Reliable Background Check Services <span>In Nigeria</span></p>
                <p class="description">Protect your organization from fraud, poor performance, and legal trouble. We
                    provide accurate,
                    actionable information for employees, domestic staff, guarantors, and bank loan applicants.
                </p>
                <div class="buttons">
                    <button class="btn-experts" (click)="scrollToId('contact-section')">
                        <p>Speak With Our Experts</p>
                        <img src="../../../../../assets/images/background-check/btn-arrow-right.svg">
                    </button>
                    <button class="btn-learn-more" (click)="scrollToId('benifits-section')">
                        <p>Learn More</p>
                    </button>
                </div>
                <div class="checks">
                    <div class="check">
                        <img src="../../../../../assets/images/background-check/check-1.svg">
                        <p>Fast Turnaround</p>
                    </div>
                    <div class="check">
                        <img src="../../../../../assets/images/background-check/check-1.svg">
                        <p>Verified Results</p>
                    </div>
                    <div class="check">
                        <img src="../../../../../assets/images/background-check/check-1.svg">
                        <p>Worldwide Coverage</p>
                    </div>
                </div>
            </div>

            <div class="banner-form">
                <div class="top">
                    <div class="badge">
                        <img src="../../../../../assets/images/background-check/shield-2.svg">
                    </div>
                    <div class="text-content">
                        <p class="title">Verification Complete</p>
                        <p class="subtitle">All checks passed</p>
                    </div>
                </div>
                <div class="fields">
                    <div class="field">
                        <p>Identity Verified</p>
                        <div>
                            <p>Confirmed</p>
                            <img src="../../../../../assets/images/background-check/check-2.svg">

                        </div>
                    </div>
                    <div class="field">
                        <p>Education</p>
                        <div>
                            <p>BSc. Computer Science</p>
                            <img src="../../../../../assets/images/background-check/check-2.svg">

                        </div>
                    </div>
                    <div class="field">
                        <p>Employment History</p>
                        <div>
                            <p>3 years verified</p>
                            <img src="../../../../../assets/images/background-check/check-2.svg">

                        </div>
                    </div>
                    <div class="field">
                        <p>Address</p>
                        <div>
                            <p>Lagos, Nigeria</p>
                            <img src="../../../../../assets/images/background-check/check-2.svg">

                        </div>
                    </div>

                </div>
                <div class="banner-form-badge">
                    <p class="title">1000+</p>
                    <p class="subtitle">Verifications Monthly</p>
                </div>
            </div>

        </div>
        <img src="../../../../../assets/images/background-check/banner-vector.png">
    </section>

    <!-- why choose us section -->
    <section class="bg-check-choose-us">
        <div class="headings">
            <div class="heading-pill">Why Choose Us</div>
            <p class="title limit-title">Why Choose Our Background Check Services?</p>
            <p class="description">
                We combine expertise, technology, and a vast network to deliver accurate and reliable verification
                results.
            </p>
        </div>
        <div class="choose-us-cards">
            <div class="choose-us-card">
                <div class="card-icon">
                    <img src="../../../../../assets/images/background-check/shield-2.svg">
                </div>
                <p class="card-title">Comprehensive Coverage</p>
                <p class="card-description">
                    From address verification to
                    credential authentication, we verify
                    all the crucial facts about your
                    candidates.
                </p>
            </div>
            <div class="choose-us-card">
                <div class="card-icon">
                    <img src="../../../../../assets/images/background-check/people.svg">
                </div>
                <p class="card-title">Support for Everyone</p>
                <p class="card-description">
                    Whether you're an employer, a
                    financial institution, or an individual,
                    our services are designed to meet
                    your needs.
                </p>
            </div>
            <div class="choose-us-card">
                <div class="card-icon">
                    <img src="../../../../../assets/images/background-check/badge.svg">
                </div>
                <p class="card-title">Expert Verification</p>
                <p class="card-description">
                    Our links with universities,
                    colleges, vocational schools, and
                    regulatory authorities guarantee
                    reliable findings.
                </p>
            </div>
            <div class="choose-us-card">
                <div class="card-icon">
                    <img src="../../../../../assets/images/background-check/wallet.svg">
                </div>
                <p class="card-title">Cost-Effective Solutions</p>
                <p class="card-description">
                    Enjoy discounted costs while using
                    our recruitment services for
                    comprehensive background
                    checks.
                </p>
            </div>
        </div>
    </section>

    <!-- what we verify section -->
    <section class="bg-check-verify">
        <div class="verify-container">
            <div class="headings">
                <div class="heading-pill">Our Services</div>
                <p class="title">What We Verify</p>
                <p class="description limit-description">Comprehensive verification services tailored to protect your
                    organization and
                    ensure informed decisions.</p>
            </div>
            <div class="verify-cards">
                <div class="verify-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/education.svg">
                    </div>
                    <p class="card-title">Certifications & Education</p>
                    <p class="card-description">
                        Ensuring that degrees, certificates, and training certifications are valid and authentic.
                    </p>
                </div>
                <div class="verify-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/employment.svg">
                    </div>
                    <p class="card-title">Employment History</p>
                    <p class="card-description">
                        Confirming former duties, responsibilities, and tenure at previous organizations.
                    </p>
                </div>
                <div class="verify-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/person-verify.svg">
                    </div>
                    <p class="card-title">Guarantor Verification</p>
                    <p class="card-description">
                        Validating the dependability and authenticity of employee guarantors.
                    </p>
                </div>
                <div class="verify-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/location.svg">
                    </div>
                    <p class="card-title">Address Verification</p>
                    <p class="card-description">
                        Confirming residential or business addresses through our extensive network.
                    </p>
                </div>
                <div class="verify-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/bank.svg">
                    </div>
                    <p class="card-title">Bank Loan Verification</p>
                    <p class="card-description">
                        Authenticating information submitted for loan applications and financial services.
                    </p>
                </div>
                <div class="verify-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/gear.svg">
                    </div>
                    <p class="card-title">Custom Verifications</p>
                    <p class="card-description">
                        Tailored checks for individual needs—if anything needs verification, we'll handle it.
                    </p>
                </div>
            </div>
        </div>
    </section>


    <!-- how it works section -->
    <section class="bg-check-how-it-works">
        <div class="how-it-works-container">
            <div class="headings">
                <div class="heading-pill">Our Process</div>
                <p class="title">How It Works</p>
                <p class="description">
                    A streamlined, transparent process designed to deliver accurate results efficiently.
                </p>
            </div>
            <div class="how-it-works-cards">
                <div class="how-it-works-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/how-it-works-1.svg">
                        <div class="divider"></div>
                    </div>
                    <p class="card-title">Client Engagement</p>
                    <p class="card-description">
                        We understand your needs and establish the scope of checks to be conducted.
                    </p>
                </div>
                <div class="how-it-works-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/how-it-works-2.svg">
                        <div class="divider"></div>
                    </div>
                    <p class="card-title">Candidate Awareness</p>
                    <p class="card-description">
                        The candidate is informed and fills out a thorough form to obtain consent.
                    </p>
                </div>
                <div class="how-it-works-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/how-it-works-3.svg">
                        <div class="divider"></div>
                    </div>
                    <p class="card-title">Verification Process</p>
                    <p class="card-description">
                        Our team undertakes in-depth verification leveraging our
                        extensive network.
                    </p>
                </div>
                <div class="how-it-works-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/how-it-works-4.svg">
                        <div class="divider"></div>
                    </div>
                    <p class="card-title">Delivery of Results</p>
                    <p class="card-description">
                        We provide a detailed, easy-to-understand report for smart
                        decision-making.
                    </p>
                </div>
            </div>
        </div>
    </section>


    <!-- benifits section -->
    <section id="benifits-section" class='bg-check-benifits'>
        <div class='benifits-container'>
            <div class='benifits-left'>
                <div class='pill'>Benifits</div>
                <p class="title">Benefits of Worknigeria Background Checks</p>
                <p class="description">Our comprehensive verification services provide you with the confidence and
                    clarity needed to make
                    informed decisions for your organization.</p>
                <div class="benifits-items">
                    <div class="benifits-item">
                        <div class="benifits-item-icon">
                            <img src="../../../../../assets/images/background-check/check-3.svg">
                        </div>
                        <div class="benifits-item-content">
                            <p class="benifits-item-title">Accurate & Reliable Reports</p>
                            <p class="benifits-item-description">
                                Gain confidence in your hiring and business decisions with verified, precise
                                information.
                            </p>
                        </div>
                    </div>
                    <div class="benifits-item">
                        <div class="benifits-item-icon">
                            <img src="../../../../../assets/images/background-check/clock.svg">
                        </div>
                        <div class="benifits-item-content">
                            <p class="benifits-item-title">Faster Turnaround</p>
                            <p class="benifits-item-description">
                                We deliver timely results without compromising on quality or thoroughness.
                            </p>
                        </div>
                    </div>
                    <div class="benifits-item">
                        <div class="benifits-item-icon">
                            <img src="../../../../../assets/images/background-check/ripple.svg">
                        </div>
                        <div class="benifits-item-content">
                            <p class="benifits-item-title">Customized Checks</p>
                            <p class="benifits-item-description">
                                Every verification process is personalized to match your specific requirements.
                            </p>
                        </div>
                    </div>
                    <div class="benifits-item">
                        <div class="benifits-item-icon">
                            <img src="../../../../../assets/images/background-check/shield-3.svg">
                        </div>
                        <div class="benifits-item-content">
                            <p class="benifits-item-title">Risk Reduction</p>
                            <p class="benifits-item-description">
                                Avoid potential fraud, misrepresentation, or liability with thorough verification.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="benifits-right">
                <div class="badge">100% Verified</div>
                <p class="title">Trusted by Organizations</p>
                <div class="grid">
                    <div class="item">
                        <p class="item-title">1000+</p>
                        <p class="item-description">Monthly Verifications</p>
                    </div>
                    <div class="item">
                        <p class="item-title">98%</p>
                        <p class="item-description">Accuracy Rate</p>
                    </div>
                    <div class="item">
                        <p class="item-title">48hrs</p>
                        <p class="item-description">Average Turnaround</p>
                    </div>
                    <div class="item">
                        <p class="item-title">500+</p>
                        <p class="item-description">Happy Clients</p>
                    </div>
                </div>
                <div class="subtitle">
                    Join hundreds of organizations that trust Worknigeria for reliable background verification.
                </div>
            </div>
        </div>
    </section>


    <!-- who sould use our services section -->
    <section class="bg-check-clients">
        <div class="clients-container">
            <div class="headings">
                <div class="heading-pill">Who We Serve</div>
                <p class="title">Who Should Use Our Services?</p>
                <p class="description limit-description">Our background check services are designed to support a wide
                    range of clients with varying verification needs.
                </p>
            </div>
            <div class="clients-cards">
                <div class="clients-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/docs.svg">
                    </div>
                    <p class="card-title">Employers</p>
                    <p class="card-description">
                        Ensure you hire trustworthy personnel
                        with verifiable credentials and clean
                        backgrounds.
                    </p>
                </div>
                <div class="clients-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/bank.svg">
                    </div>
                    <p class="card-title">Financial institutions</p>
                    <p class="card-description">
                        Verify application information for loan
                        approvals and reduce lending risks.
                    </p>
                </div>
                <div class="clients-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/person.svg">
                    </div>
                    <p class="card-title">Individuals</p>
                    <p class="card-description">
                        Authenticate domestic staff or
                        personal service providers.
                    </p>
                </div>
                <div class="clients-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/background-check/people.svg">
                    </div>
                    <p class="card-title">HR Professionals</p>
                    <p class="card-description">
                        Streamline your employee verification
                        process with our professional expertise.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <!-- contact us section -->
    <section id="contact-section" class="bg-check-contact">
        <div class="contact-container">
            <div class="contact-left">
                <div class="pill">Get Started</div>
                <p class="title">
                    Partner with Worknigeria
                    for Reliable Background
                    Checks
                </p>
                <p class="description">
                    Let us handle the complexity of verification so you can focus on what matters. Our rigorous and fast
                    process ensures peace of mind for every decision you make.
                </p>
                <div class="contact-info">
                    <div class="contact-item">
                        <div class="item-icon">
                            <img src="../../../../../assets/images/background-check/email.svg">
                        </div>
                        <p class="text">sales@worknigeria.com</p>
                    </div>
                    <div class="contact-item">
                        <div class="item-icon">
                            <img src="../../../../../assets/images/background-check/phone.svg">
                        </div>
                        <p class="text">+234 913 700 0206 | +234 803 474 4356</p>
                    </div>
                </div>
            </div>
            <div class="contact-right">
                <p class="title">Get a Free Consultation</p>
                <p class="description">
                    Get expert advice on effective employee verification—for free. Fill out the form to get started.
                </p>
                <form [formGroup]="consultationForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <p class="field">Full Name</p>
                        <input type="text" required formControlName="name">
                    </div>
                    <div class="form-group">
                        <p class="field">Email Address</p>
                        <input type="email" required formControlName="email">
                    </div>

                    <div class="form-group">
                        <p class="field">Phone Number</p>
                        <input type="tel" required formControlName="phone">
                    </div>

                    <button type="submit" class="btn-submit">
                        <p class="btn-text">Submit Request</p>
                        <img src="../../../../../assets/images/background-check/send.svg">
                    </button>
                </form>
            </div>
        </div>
    </section>

</div>